import lagosSkyline from './assets/home/cities/lagos.jpg';
import ibadanSkyline from './assets/home/cities/ibadan.jpg';
import portHarcourtSkyline from './assets/home/cities/port-harcourt.jpg';
import enuguSkyline from './assets/home/cities/enugu.jpg';
import abujaSkyline from './assets/home/cities/abuja.jpg';

export const homeHero = {
  title: 'Find your next rental or short-let stay across Nigeria',
};

export const popularCities = [
  {
    name: 'Lagos',
    description: 'Urban estates and high-demand rentals.',
    image: lagosSkyline,
    state: 'Lagos',
  },
  {
    name: 'FCT Abuja',
    description: 'Planned neighborhoods with executive housing.',
    image: abujaSkyline,
    state: 'FCT',
  },
  {
    name: 'Port Harcourt',
    description: 'Serviced homes and gated compounds.',
    image: portHarcourtSkyline,
    state: 'Rivers',
  },
  {
    name: 'Ibadan',
    description: 'Affordable family homes and rentals.',
    image: ibadanSkyline,
    state: 'Oyo',
  },
  {
    name: 'Enugu',
    description: 'Calm neighborhoods, modern development.',
    image: enuguSkyline,
    state: 'Enugu',
  },
];

export const steps = [
  {
    title: 'Search',
    description: 'Choose your location, budget, and whether you want to rent, book a short-let, or buy.',
  },
  {
    title: 'Connect',
    description: 'Contact hosts, landlords, or agents directly and confirm details before any payment.',
  },
  {
    title: 'Move',
    description: 'Move in or check in, agree terms, and settle with confidence.',
  },
];
